import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

// Components
import {
  Tabs,
  Tab,
  EvaluationTile,
  StatusBar,
  CloseButton,
} from '../../../../components'

// Constants
import { TABS } from '../../../../constants/display'

// Hooks
import { useLoading } from '../../../../hooks/loading'

// Styles
import styles from './Header.module.scss'

const Header = ({ activeTab, onTabClick, onClose }) => {
  const { settledRequest } = useLoading()

  return (
    <div className={classnames(styles.header)}>
      <div className={styles.topRow}>
        <EvaluationTile />
        <CloseButton className={styles.close} onClick={onClose} />
      </div>
      <div className={styles.tabRow}>
        <div className={styles.tabDividerTop}></div>
        <Tabs activeTab={activeTab} onClick={onTabClick}>
          <Tab label={TABS.OVERVIEW} />
          <Tab label={TABS.TEAM} />
          <Tab label={TABS.SETTINGS} />
        </Tabs>
        <StatusBar thinking={!settledRequest} className={styles.statusBar} />
        <div className={styles.tabDividerBottom}></div>
      </div>
    </div>
  )
}

Header.propTypes = {
  onClose: PropTypes.func.isRequired,
  activeTab: PropTypes.string.isRequired,
  onTabClick: PropTypes.func.isRequired,
}

export default Header
